export const sidebarMenus = [
  {
    position: "top",
    children: [
      {
        key: "pulse",
        label: "Pulse",
        link: "/pulse",
        icon: "bx bx-pulse",
        children: [],
      },
      {
        key: "pulse-reports",
        label: "Reports",
        link: "/pulse/reports",
        icon: "bx bx-file",
        children: [],
      },
      {
        key: "dashboard",
        label: "Legacy KPI",
        link: "/kpi",
        icon: "bx bxs-dashboard",
        children: [],
      },
    ],
  },
  {
    position: "bottom",
    children: [
      {
        key: "pulse-admin",
        label: "Pulse Admin",
        link: "/pulse/admin",
        icon: "bx bx-cog",
        children: [],
      },
      {
        key: "logout",
        label: "Logout",
        link: "",
        icon: "bx bx-power-off",
        children: [],
      },
    ],
  },
];
